import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  savedMessagesKey,
  errorMessage,
} from '@features/savedMessages';
import axiosInstance from '@server/axiosInstance';
import { tampleteSavedMessagesRoute } from '../api/constants';

type useCreateTemplateSavedMessageProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useCreateTemplateSavedMessage = ({
  setErrorText,
}: useCreateTemplateSavedMessageProps) => {
  const client = useQueryClient();

  const { mutate: createSavedMessage, isLoading: isCreatingSavedMessage } =
    useMutation({
      mutationFn: (variables: {
        label: string;
        content: string;
        etemplate_id: number
      }) =>
        axiosInstance
          .post(tampleteSavedMessagesRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries([savedMessagesKey]);
        }
      },
      onError: (error: { message?: string }) => {
        setErrorText(error?.message || errorMessage);
      },
    });

  return {
    createSavedMessage,
    isCreatingSavedMessage,
  };
};
